module.exports = __webpack_public_path__ + "static/media/uosgy_pc_top.2b882fcb.jpg";